import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

export const SelectControlPanel = (props:any) => {
  const [selectedFeature, setSelectedFeature] = useState<any>(null);
  const [copiedFeature, setCopiedFeature] = useState<any>(null);

  useEffect(() => {
    console.log('selectedFeature', props.selectedFeature);
    setSelectedFeature(props.selectedFeature);
  }, [props.selectedFeature]);

  useEffect(() => {
    setCopiedFeature(props.copiedFeature);
  }, [props.copiedFeature]);

  return (
    <div className="control-panel text-dark shadow-sm rounded" style={{width: "425px", top: 0}}>
      {
        selectedFeature != null ?
           <dl className="border-bottom pb-2 row">
            <dt className="col-sm-3">Owner</dt>
            <dd className="col-sm-9">{selectedFeature.properties['owner']}</dd>
            <dt className="col-sm-3">Address</dt>
            <dd className="col-sm-9">{selectedFeature.properties['address']}</dd>
            <dt className="col-sm-3">Parcel</dt>
            <dd className="col-sm-9">{selectedFeature.properties['parcelnumb']}</dd>
          </dl>
          : null
      }
      <ol className="pl-4 pl-3 text-sm" type="1">
        <li>Select a parcel</li>
        <li>Click the "Copy" button</li>
        <li>Select the copied parcel to make updates</li>
      </ol>
      <Button variant="primary" size="sm" disabled={!(selectedFeature != null && copiedFeature == null)} onClick={(e:any) => {
          if(props.onCopy) {
              props.onCopy();
          }
      }}>
          Copy
      </Button>
      <Button variant="primary" size="sm" className="mx-2" disabled={!(copiedFeature != null)}  onClick={(e:any) => {
          if(props.onClear) {
              props.onClear();
          }
      }}>
          Clear
      </Button>
    </div>
  );
}